import { useDispatch } from 'react-redux';

import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import { showSnackbar } from 'hooks/useSnackbar';
import { removeFontThunk } from 'store/fonts/thunks';

function useTable({ fontsCollection, getFonts, activeFontIds, setActiveFontIds }) {
  const dispatch = useDispatch();
  const isNoData = fontsCollection?.length === 0;

  const handleCheck = (enteredId) => {
    if (!enteredId) return;
    const isInclude = activeFontIds.includes(enteredId);
    if (isInclude) return setActiveFontIds((activeIds) => activeIds.filter((activeId) => activeId !== enteredId));
    return setActiveFontIds((prev) => [...prev, enteredId]);
  };
  const handleRemove = async (enteredId) => {
    try {
      await dispatch(removeFontThunk({ id: enteredId }));
      await getFonts();
      showSnackbar({ text: 'Successfully deleted' });
    } catch (err) {
      showSnackbar({ text: 'Oops! Something went wrong', type: SNACKBAR_SKIN.ERROR });
    }
    // setFontsCollection((fonts) => fonts.filter((font) => font.id !== enteredId));
    // setActiveFontIds((ids) => ids.filter((id) => id !== enteredId));
  };

  return { fontsCollection, isNoData, handleCheck, activeFontIds, handleRemove };
}

export default useTable;
